module.exports = __webpack_public_path__ + "img/max-person-edit.6e6fa442.svg";